export class GetExternalReportBrandingError extends Error{}